module.exports = __webpack_public_path__ + "static/Exo2-ef07dc22e614f5520aeed02f4ee75e58.ttf";